import { render, staticRenderFns } from "./story-banner-icon.vue?vue&type=template&id=0e6dbb36&functional=true&"
import script from "./story-banner-icon.vue?vue&type=script&lang=js&"
export * from "./story-banner-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports